import { useEffect, useState } from "react"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import styles from './styles.module.css'


const ValidadorSenha = ({ senha, setSenhaCompleta }) => {
  const [validacaoSenha, setValidacaoSenha] = useState({
    tamanho: false,
    especial: false,
    maiuscula: false,
    minuscula: false,
    numero: false
  })

  const validarSenha = () => {
    const tamanho = senha.length >= 10
    const especial = /[!@#$%^&*(),.?":{}|<>]/.test(senha)
    const maiuscula = /[A-Z]/.test(senha)
    const minuscula = /[a-z]/.test(senha)
    const numero = /\d/.test(senha)

    const validacao = {
      tamanho,
      especial,
      maiuscula,
      minuscula,
      numero
    }

    setValidacaoSenha({ ...validacaoSenha, ...validacao })
  }

  const handleVerificador = () => {
    if (validacaoSenha.especial
      && validacaoSenha.maiuscula
      && validacaoSenha.minuscula
      && validacaoSenha.numero
      && validacaoSenha.tamanho) {
      setSenhaCompleta(true)
    } else {
      setSenhaCompleta(false)
    }
  }

  useEffect(() => {
    validarSenha()
  }, [senha])

  useEffect(() => {
    handleVerificador()
  }, [validacaoSenha])

  return (
    <>
      {senha ?
        <ul className={styles.validacao_senha}>
          <li
            className={validacaoSenha.tamanho ? styles.validacao_true : styles.validacao_false}
          >Mínimo de 10 caracteres {validacaoSenha.tamanho && <CheckCircleIcon sx={{ fontSize: '.9rem', marginLeft: '4px' }} />}
          </li>
          <li
            className={validacaoSenha.especial ? styles.validacao_true : styles.validacao_false}
          > Caracter especial {validacaoSenha.especial && <CheckCircleIcon sx={{ fontSize: '.9rem', marginLeft: '4px' }} />}
          </li>
          <li
            className={validacaoSenha.maiuscula ? styles.validacao_true : styles.validacao_false}
          > Letra maiúscula {validacaoSenha.maiuscula && <CheckCircleIcon sx={{ fontSize: '.9rem', marginLeft: '4px' }} />}
          </li>
          <li
            className={validacaoSenha.minuscula ? styles.validacao_true : styles.validacao_false}
          > Letra minúscula {validacaoSenha.minuscula && <CheckCircleIcon sx={{ fontSize: '.9rem', marginLeft: '4px' }} />}
          </li>
          <li
            className={validacaoSenha.numero ? styles.validacao_true : styles.validacao_false}
          > Número {validacaoSenha.numero && <CheckCircleIcon sx={{ fontSize: '.9rem', marginLeft: '4px' }} />}
          </li>
        </ul> : ''
      }
    </>
  )
}

export default ValidadorSenha